import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Timestamp } from 'firebase/firestore';
import './index.css';
import './variables.css'
import App from './App/App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {width, height};
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export function flagEmpty(element) {
  element.focus();
  element.classList.add('empty-field');  
}
export function notEmpty(e) {
  e.target.classList.remove('empty-field');
}

export function toTimestamp(date) {
  return new Timestamp(date.getTime() / 1000 + 8*60*60, 0);
}
